var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64056 15.1875C5.4225 15.1875 2.8125 12.6039 2.8125 9.41734C2.8125 6.23078 5.42194 3.64722 8.64056 3.64722C11.8597 3.64722 14.4692 6.23078 14.4692 9.41734C14.4692 12.6039 11.8592 15.1875 8.64 15.1875H8.64056ZM9.64687 5.3004C11.0059 5.85672 11.9824 6.90353 12.6754 8.31428L13.1985 7.95034C12.6112 6.53734 11.5262 5.42697 9.78075 4.70697L9.64687 5.3004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.183 5.24306C15.183 3.90094 14.0833 2.8125 12.7277 2.8125C11.3721 2.8125 10.2724 3.90094 10.2724 5.24306C10.2724 5.37131 10.2825 5.499 10.3027 5.62556C11.1201 6.10144 11.7765 6.78431 12.3013 7.63706C12.4419 7.66125 12.5848 7.67419 12.7277 7.67419C14.0833 7.67419 15.183 6.58575 15.183 5.24306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdd);
export default __webpack_public_path__ + "static/media/rdd.f49597e24fb58966812620b0dbe74c0a.svg";
export { ForwardRef as ReactComponent };